import {} from "../half-edge/index.js";
import {} from "../port/index.js";
import {} from "./Net.js";
import { findHalfEdgeEntryOrFail } from "./findHalfEdgeEntryOrFail.js";
export function findHalfEdgePortOrFail(net, halfEdge) {
    const halfEdgeEntry = findHalfEdgeEntryOrFail(net, halfEdge);
    if (halfEdgeEntry.port === undefined) {
        console.trace();
        throw new Error(`[findHalfEdgePortOrFail] I expect halfEdgeEntry to have port.`);
    }
    return halfEdgeEntry.port;
}
//# sourceMappingURL=findHalfEdgePortOrFail.js.map